export function mapConnectionLevel(quality) {
  if (quality === null || quality === undefined) {
    return null;
  }

  const value = Number(quality);

  if (Number.isNaN(value)) {
    return null;
  }

  if (value <= 2) {
    return 3;
  }

  if (value <= 4) {
    return 2;
  }

  return 1;
}

export function buildChartData(records, salaId) {
  const filtered = (records || []).filter((record) => {
    if (!salaId) {
      return true;
    }

    return Number(record.sqc_id_salas || record.idSalas) === Number(salaId);
  });

  if (!filtered.length) {
    return {
      points: [],
      latency: [],
      connection: []
    };
  }

  const sorted = [...filtered].sort(
    (a, b) => new Date(a.sqc_created_at) - new Date(b.sqc_created_at)
  );

  const endTime = new Date(sorted[sorted.length - 1].sqc_created_at).getTime();

  const points = sorted.map((record) => {
    const createdAt = new Date(record.sqc_created_at).getTime();
    const minutes = Math.round((createdAt - endTime) / 60000);
    const quality = record.sqc_downlink_network_quality ?? record.sqc_uplink_network_quality;

    return {
      x: minutes,
      latency: Number(record.sqc_send_rtt_ms) || 0,
      connection: mapConnectionLevel(quality) || 0
    };
  });

  return {
    points,
    latency: points.map((point) => [point.x, point.latency]),
    connection: points.map((point) => [point.x, point.connection])
  };
}
